import { render, staticRenderFns } from "./propose-choice.vue?vue&type=template&id=15250f8b"
import script from "./propose-choice.vue?vue&type=script&lang=ts"
export * from "./propose-choice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15250f8b')) {
      api.createRecord('15250f8b', component.options)
    } else {
      api.reload('15250f8b', component.options)
    }
    module.hot.accept("./propose-choice.vue?vue&type=template&id=15250f8b", function () {
      api.rerender('15250f8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/propose-choice.vue"
export default component.exports